export const FollowUpViewUpdate = () => {
    return (
        <div>
            FollowUpViewUpdate
        </div>
    )
}